export const environment = {
  production: true,
  name: "production",
  drupalUsername: "",
	location: "TBD",
  drupalPassword: "",
  drupalUrl: 'https://app.am.arthurmurray.com',
  hostUrl: 'https://app.am.arthurmurray.com',
  subFolder: '/app/',
  logRocketKey: 'i7mbrj/agendamaster-production',
  stripePublicKey: '',
  stripePublicKeyFetchUrl: '/api/stripe-public-key',
  // Subscription and payment redirect URLs
  successRedirectUrl: 'https://app.am.arthurmurray.com/subscription/confirmation?session_id={CHECKOUT_SESSION_ID}',
  cancelRedirectUrl: 'https://app.am.arthurmurray.com/subscription/canceled'
};
